/**
 * A default set of spring presets.
 * Use this set of spring props when animating a single component.
 */
var primary = {
  damping: 40,
  mass: 1.05,
  stiffness: 900,
  velocity: 3.67
};
/**
 * Inspired by react-spring.io's default motion
 * Subtle and soft, with less bounce.
 */

var secondary = {
  damping: 22,
  mass: 1,
  stiffness: 209,
  velocity: 3.5
};
/**
 * Effective for modals and popups.
 * This motion will bring attention to the element at play.
 * And should be the only focus at time of the animation.
 */

var modal = {
  damping: 40,
  mass: 2.0,
  stiffness: 500,
  velocity: 3.5
};
/**
 * For use when sliding elements into view
 */

var slide = {
  damping: 60,
  mass: 1.5,
  stiffness: 850,
  velocity: 5.5
};
/**
 * A default set of spring presets.
 * Use this set of spring props when animating a series of children.
 */

var list = {
  damping: 45,
  mass: 1.85,
  stiffness: 900,
  velocity: 15
};
/**
 * A softer alternative to the above list option.
 * Not as bouncy but makes the list elements feel responsive to one another.
 */

var listSoft = {
  damping: 20,
  mass: 1.15,
  stiffness: 165,
  velocity: 5.6
};
/**
 * A collection of spring defined presets for use in animations.
 * @returns SpringPreset - {object}
 */

export var springs = {
  primary: primary,
  secondary: secondary,
  modal: modal,
  slide: slide,
  list: list,
  listSoft: listSoft
};